import Api from "../Helpers/Api";

class FeedBackService {
  getFeedBack() {
    return Api.get(`/feedback`);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new FeedBackService();